import { useDeviceStore } from '@remote/store/device';
import { defineComponent } from 'vue';
import { useStore, mapState, mapGetters } from 'vuex';
export default defineComponent({
  props: ['close'],
  setup() {
    const store = useStore();
    return {
      store
    };
  },
  data() {
    return {
      numList: [1, 2, 3, 4, 5],
      num: 5
    };
  },
  computed: {
    ...mapState([]),
    ...mapGetters(['runnerConfig']),
    runnerCount() {
      return this.runnerConfig.runner_count;
    }
  },
  beforeUnmount() {
    this.$stat({
      action: 'downloadtask_num_supernatant_close',
      data: {
        num: this.num
      }
    });
  },
  methods: {
    async selected(select) {
      this.num = select;
      console.log('select', select);
      console.log('this.runnerConfig', this.runnerConfig);
      try {
        await this.store.dispatch('setDeviceConfig', {
          runner_count: select
        });
        const deviceStore = useDeviceStore();
        deviceStore.pollRunnerList().then(() => {
          this.store.commit('toast', '设置成功');
        });
      } catch (error) {
        console.log(error);
      } finally {
        this.$stat({
          action: 'remote_device_supernatant_close',
          data: {
            num: select
          }
        });
        this.close();
      }
    }
  }
});